.showMoreButton {
    margin-top: 10px;
}